import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowRight, ClipboardCheck, FlaskConical, Factory, HandCoins } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  id: "01",
  title: "Evaluate",
  description: "We review catalyst type, application, quantity, and replacement schedule to determine recovery potential. Early assessment prevents unnecessary disposal costs.",
  icon: ClipboardCheck,
  link: "/OurServicesPage"
}, {
  id: "02",
  title: "Sample & Test",
  description: "CRG coordinates proper sampling and sends samples to independent qualified labs for assay testing to confirm precious metal concentration.",
  icon: FlaskConical,
  link: "/OurServicesPage"
}, {
  id: "03",
  title: "Recover & Refine",
  description: "Once value is confirmed, materials are safely transported and processed through experienced refining partners using compliant, proven recovery methods.",
  icon: Factory,
  link: "/OurServicesPage"
}, {
  id: "04",
  title: "Return Value",
  description: "Clients receive payment based on verified results with full visibility into testing, refining, and settlement terms.",
  icon: HandCoins,
  link: "/OurServicesPage"
}];
export default function OurFourStepMethodology() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-four-step-methodology" ref={ref} className="relative w-full overflow-hidden bg-background transition-opacity duration-700 opacity-100 ![padding:90px_0px_90px_0px]">
      {}

 

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-8">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">Simple and Profitable Catalyst Recovery</h2>
          <p className="text-lg !text-[hsl(210,16%,93%)] mb-0"><b>We manage the recovery process from start to finish so your team does not have to. From scheduling pickup and handling logistics to coordinating sampling and testing, we keep everything organized and moving efficiently. Our goal is to reduce disruption to your operation while helping you get the most value from your spent material.</b></p>
        </div>

        
      </div>
    <div className="w-full h-[10px] -translate-y-1/2 hidden lg:block pointer-events-none z-0 mb-8">
        <div className="w-full h-full flex items-center justify-center">
          <div className="w-[85%] h-[2px] bg-gradient-to-r from-transparent via-border to-transparent opacity-50" />
        </div>
      </div>

    <div class="container mx-auto px-4 md:px-6 relative z-10">
      <h2 className="!font-sans !text-4xl !font-normal !text-center !text-[hsl(210,17%,98%)] ![padding:0px_0px_16px_0px]"><b>Industries We Serve</b></h2>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="!text-2xl">Petroleum refining | Petrochemical Processing | Chemical Manufacturing | Industrial Process Plants</p>
        </div>
        <div className="mt-8 flex justify-center">
          <Button asChild size="lg" className="bg-chart-1 text-primary hover:bg-chart-1/90 h-14 rounded-none px-8 text-base font-bold tracking-wide uppercase shadow-none transition-colors">
            <Link to="/contact">
              Talk to an Expert
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
    </div>
    </section>;
}